import type { Aluno } from '@/domain/model/Aluno';
import type { VerificarContatoAlunoUseCase } from '@/application/port/in/VerificarContatoAlunoUseCase';
import type { AlunoGateway } from '@/application/port/out/AlunoGateway';

export class VerificarContatoAluno implements VerificarContatoAlunoUseCase {
  constructor(private readonly gateway: AlunoGateway) {}
  verificarEmail(alunoId: string): Promise<Aluno>    { return this.gateway.verificarEmail(alunoId); }
  desverificarEmail(alunoId: string): Promise<Aluno> { return this.gateway.desverificarEmail(alunoId); }
  verificarCelular(alunoId: string): Promise<Aluno>    { return this.gateway.verificarCelular(alunoId); }
  desverificarCelular(alunoId: string): Promise<Aluno> { return this.gateway.desverificarCelular(alunoId); }
}
